import { Component, OnInit } from "@angular/core";
import { AuthenticationService } from "../services/authentication.service";
import { take } from "rxjs/operators";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
  FormArray,
} from "@angular/forms";
import { UserService } from "../services/user.service";
import { Router } from "@angular/router";
import { forEach } from "@angular/router/src/utils/collection";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  operation = "login";

  email: string = null;
  password: string = null;
  name: string = null;
  lastname: string = null;
  identification: string = null;
  bday: Date = null;
  errorMessage = "";
  alertMessage = "";
  successMessage = "";
  formRef: FormGroup;
  minDate: Date;

  constructor(
    private authService: AuthenticationService,
    private userService: UserService,
    private router: Router,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.createForm();
    this.authService.getStatus().subscribe((status) => {
      if (status != null) {
        if (!status.emailVerified) {
          this.alertMessage =
            "Hemos enviado un correo electrónico de validación a tu correo registrado. Por favor revisa tu bandeja de entrada.";
        }
      }
    });
    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate());
  }
  createForm() {
    if (this.operation === "login") {
    }
    this.formRef = this.formBuilder.group({
      email: ["", Validators.compose([Validators.required, Validators.email])],
      password: [
        "",
        Validators.compose([Validators.required, Validators.minLength(6)]),
      ],
      name: [""],
      lastname: [""],
      identification: [""],
      bday: [""],
    });
  }
  login() {
    if (this.email != null && this.password != null) {
      this.authService
        .persistenceAuthSession()
        .then(() => {
          this.authService
            .loginWithEmail(this.email, this.password)
            .then(() => {
              this.authService.getStatus().subscribe((status) => {
                this.userService
                  .getUserById(status.uid)
                  .valueChanges()
                  .pipe(take(1))
                  .subscribe((v) => {
                    let activity = v["active"];
                    if (activity == 0) {
                      const active = {
                        uid: status.uid,
                        value: 1,
                      };
                      this.userService
                        .setActive(active)
                        .then((a) => {
                          this.router.navigate(["home"]);
                        })
                        .catch((error) => {
                          console.log(error);
                        });
                    } else if (activity == 1) {
                      const active = {
                        uid: status.uid,
                        value: 2,
                      };
                      this.userService
                        .setActive(active)
                        .then((a) => {
                          this.router.navigate(["home"]);
                        })
                        .catch((error) => {
                          console.log(error);
                        });
                    } else {
                      this.router.navigate(["home"]);
                    }
                  });
              });
            })
            .catch((error) => {
              console.log(error.code);
              switch (error.code) {
                case "auth/user-not-found":
                  this.errorMessage = "Usuario no registrado";
                  break;
                case "auth/invalid-email":
                  this.errorMessage =
                    "Correo electrónico o contraseña incorrecta";
                  break;
                case "auth/wrong-password":
                  this.errorMessage =
                    "Correo electrónico o contraseña incorrecta";
                  break;
                case "auth/too-many-requests":
                  this.errorMessage =
                    "¿Tienes problemas para iniciar sesión? Comuníquese con nosotros.";
                  break;
              }
            });
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      this.errorMessage = "1 campos vacíos o incorrectos";
    }
  }
  register() {
    this.authService
      .registerWithEmail(this.email, this.password)
      .then((data) => {
        const user = {
          uid: data.user.uid,
          name: this.name,
          lastname: this.lastname,
          identification: this.identification,
          bday: this.bday.toString(),
          email: this.email.toLowerCase(),
          rol: "user",
          active: 0,
        };
        this.authService
          .sendEmailVerification()
          .then(() => {
            this.userService
              .setUser(user)
              .then(() => {
                this.successMessage = "Se ha registrado correctamente";
                this.operation = "login";
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        switch (error.code) {
          case "auth/email-already-in-use":
            this.errorMessage =
              "1-Registro: Usuario con ese correo ya registrado";
            break;
          case "auth/weak-password":
            this.errorMessage = "2-Registro: Formato de contraseña incorrecto";
            break;
        }
      });
  }
  addValidation() {
    this.formRef.get("name").setValidators(Validators.required);
    this.formRef.get("lastname").setValidators(Validators.required);
    this.formRef.get("identification").setValidators(Validators.required);
    this.formRef.get("bday").setValidators(Validators.required);
  }
  removeValidation() {
    this.formRef.get("name").clearValidators();
    this.formRef.get("lastname").clearValidators();
    this.formRef.get("identification").clearValidators();
    this.formRef.get("bday").clearValidators();
  }
}
